import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';

@Component({
  selector: 'app-sign-out-ask-dialog',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle
  ],
  template: `
    <h2 mat-dialog-title>Cerrar sesión</h2>
    <mat-dialog-content>
      <p>¿Estás seguro de que deseas cerrar sesión?
      </p>

    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button mat-dialog-close cdkFocusInitial>No, Cancelar</button>
      <button mat-button [mat-dialog-close]="true" >Si</button>
    </mat-dialog-actions>

  `,
})
export class SignOutAskDialogComponent {

}
